import { Validators } from "@angular/forms";
import { TableCols } from "../interfaces/static-data";
import { micFormatValidator } from "../../validators/mic-format.validator";

export const ListingVenueColumns: TableCols[] = [
    {
        key: 'longName',
        displayValue: 'Long Name',
        validators:[Validators.required],
    },
    {
        key: 'shortName',
        displayValue: 'Short Name'
    },
    {
        key: 'description',
        displayValue: 'Description'
    },
    {
        key: 'website',
        displayValue: 'Website'
    },
    {
        key: 'regulated',
        displayValue: 'Regulated',
        type: 'boolean',
        items: [
            {
                id: true,
                displayValue: 'Yes'
            },
            {
                id: false,
                displayValue: 'No'
            }
        ]
    },
    {
        key: 'micCode',
        displayValue: 'MIC Code',
        validators: [Validators.required, micFormatValidator()],
    },
    {
        key: 'workflowStatus',
        displayValue: 'Workflow Status',
        hideOnForm: true
    },
    {
        key: 'lastUpdatedBy',
        displayValue: 'Last Updated By',
        hideOnForm: true
    },
    {
        key: 'updatedOn',
        displayValue: 'Updated On',
        hideOnForm: true
    },
    {
        key: 'deletedAt',
        displayValue: 'Deleted On',
        hideOnForm: true
    },
];
